import { Component, Input, OnInit } from '@angular/core';
import { CardLinkingOfferLocations, 
         CardLinkOfferLocationsQuery, 
         CardLinkOfferLocationsService, 
         CardLinkOfferLocationOptions } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-card-link-offer-locations',
  templateUrl: './card-link-offer-locations.component.html',
  styleUrls: ['./card-link-offer-locations.component.scss'],
})
export class CardLinkOfferLocationsComponent implements OnInit {
  @Input() offerId: number;
  @Input() latitude: number;
  @Input() longitude: number;
  @Input() set options(value: CardLinkOfferLocationOptions){
    this._options = { ...this._options, ...value };
  }
  get options(){
    return this._options;
  }
  private _options: CardLinkOfferLocationOptions = { showLocations: false, showMap: false, animate: true };
  currentTab: string = 'list-view';
  cardLinkOfferLocations$: Observable<CardLinkingOfferLocations | undefined>;

  constructor(
    private cardLinkOfferLocationsService: CardLinkOfferLocationsService,
    private cardLinkOfferLocationsQuery: CardLinkOfferLocationsQuery
  ) {}

  ngOnInit(): void {

    if(!this.options.showLocations){
      return;
    }

    this.cardLinkOfferLocationsService.fetchOfferLocations(this.offerId).toPromise();
    this.cardLinkOfferLocations$ = this.cardLinkOfferLocationsQuery.selectEntity(this.offerId);
    
  }
}
